import { Box, Grid, Typography } from '@mui/material'
import { ComponentCatalogExample } from './ComponentCatalogExample'
import { ComponentCatalogSection } from './ComponentCatalogSection'

interface ColorExampleProps {
  name: string
  token: string
  border?: boolean
  children?: React.ReactNode
}

const ColorExample = ({
  name,
  token,
  children,
  border = false,
}: ColorExampleProps) => {
  return (
    <ComponentCatalogExample name={name}>
      <Box display="flex" flexDirection="row">
        <Box
          width="32px"
          height="32px"
          sx={{
            backgroundColor: token,
            border: border ? '1px solid #888' : 'none',
            marginRight: '8px',
            flexShrink: 0,
          }}
        />
        {children}
      </Box>
    </ComponentCatalogExample>
  )
}

export const ColorSection = () => {
  return (
    <ComponentCatalogSection name="Colors">
      <Grid
        container
        rowSpacing="16px"
        columnSpacing={{
          xs: '24px',
          sm: '24px',
          md: '16px',
          lg: '24px',
          xl: '24px',
        }}
      >
        <ColorExample name="primary" token="primary.main" />
        <ColorExample name="secondary" token="secondary.main" />
        <ColorExample name="info" token="info.main" />
        <ColorExample name="background" token="background.paper" border />
        <ColorExample name="text.primary" token="text.primary">
          <Typography variant="body-1" color="text.primary">
            Color was not given to us in order that we should imitate Nature. It
            was given to us so that we can express our emotions.
          </Typography>
        </ColorExample>

        <ColorExample name="text.secondary" token="text.secondary">
          <Typography variant="body-1" color="text.secondary">
            If I close my eyes, I see things better than with my eyes open.
          </Typography>
        </ColorExample>

        <ColorExample name="text.disabled" token="text.disabled">
          <Typography variant="body-1" color="text.disabled">
            To visualize a solution is what matters: to make visible that which
            still does not exist outside of me.
          </Typography>
        </ColorExample>
      </Grid>
    </ComponentCatalogSection>
  )
}
